var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhylloIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6273 36.3449C21.938 33.7399 78.0197 36.3015 78.0197 36.3015L51.8089 70.6671C51.8089 70.6671 40.341 57.8778 36.5652 53.4368C32.7894 48.9959 23.3165 38.9499 22.6273 36.3449Z",
    fill: "#2262ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.636 44.1641C22.6952 41.828 78.0214 36.3002 78.0214 36.3002L51.8106 70.6658C51.8106 70.6658 39.4802 59.6157 37.1962 57.2113C34.9123 54.8069 24.5768 46.5002 23.636 44.1641Z",
    fill: "#6D31C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8486 52.7925C24.3807 51.0539 78.0348 36.2995 78.0348 36.2995L51.8239 70.6651C51.8239 70.6651 41.0938 64.398 38.468 62.245C35.8423 60.092 27.3165 54.5311 25.8486 52.7925Z",
    fill: "#FF7D50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1299 62.2178C28.9059 60.2897 78.0382 36.2999 78.0382 36.2999L51.8274 70.6655C51.8274 70.6655 45.2742 68.9306 41.3128 67.2923C36.7736 65.4151 31.3539 64.1459 30.1299 62.2178Z",
    fill: "#F9B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhylloIcon);
export default __webpack_public_path__ + "static/media/phyllo_icon.4ff1ac0afc0ffd71e52b82415e9c136a.svg";
export { ForwardRef as ReactComponent };